module.exports = __webpack_public_path__ + "images/category_lp/earphone/store_images/4_459cc0933b39bda3986a356cfd11e4f7.png";